import { useRouteError, isRouteErrorResponse } from "react-router-dom";

const PageNotFound = () => {
	const error = useRouteError();

	console.error(error);

	function processError() {
		if (isRouteErrorResponse(error)) {
			const message = error.statusText || 
				(typeof error.data === 'string' ? error.data : '') ||
				(error.data && typeof error.data === 'object' && 'message' in error.data ? String(error.data.message) : '') ||
				`Error ${error.status}`;
			return (<i>{message}</i>)
		} else if (error instanceof Error) {
			return (<i>{error.message}</i>)
		} else if (typeof error === 'string') {
			return (<i>{error}</i>)
		} else {
			return (<i>Unknown error</i>)
		}
	}

	return (
		    <div id="error-page">
		      <h1>Oops!</h1>
		      <p>Sorry, an unexpected error has occurred.</p>
		      <p>{ processError()}</p>
		    </div>
	)
}

export default PageNotFound;


